<div mat-dialog-title class="dialog-header">
  <button type="button" class="close-button" (click)="close()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>

  <h4>Response / Error</h4>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <div class="pad-10">
    <h4 *ngIf="data.responseCode === 200">Response</h4>
    <h4 *ngIf="data.responseCode !== 200">Error</h4>
    
    <div>
      <span *ngIf="isLoading" class="loading">Loading ... JSON: {{isJSON}}</span>
      <pre *ngIf="isJSON">{{response | json}}</pre>
      <pre *ngIf="isXml">{{response | xml}}</pre>
      <pre *ngIf="!isJSON && !isXml">{{response}}</pre>
    </div>
  </div>
</div>
